/**
 * @file PagePublicationsGroup.tsx
 * @description Группа «Публикации» — первая в «Настройках страницы»
 * (phase19.16 Р3а; uiux-r3 §3.1, SB122 `?group=publications`): сводка у
 * свёрнутой — «3 правки» / «всё опубликовано» / «ещё не была на сайте»;
 * внутри — `PagePublications`. Пилюля «Страница: N правок ›» в шапке
 * раскрывает её на ПК.
 */

import { SettingsGroup } from "../../ui/settings-groups";
import { useBuilder } from "../builder-context";
import { PagePublications } from "./PagePublications";
import { PUBLICATIONS_GROUP } from "../../../hooks/site-builder/usePublicationsUi";
import { draftEditCount, editsWord } from "../../../lib/site-builder/page-status";

export function PagePublicationsGroup() {
  const { changes } = useBuilder().publishing;
  let summary = "проверяем…";
  if (changes) {
    if (changes.live === null) summary = "ещё не была на сайте";
    else if (changes.hasChanges) summary = editsWord(Math.max(1, draftEditCount(changes)));
    else summary = "всё опубликовано";
  }
  return (
    <SettingsGroup id={PUBLICATIONS_GROUP} title="Публикации" summary={summary}>
      <PagePublications />
    </SettingsGroup>
  );
}
